import { gql } from "@apollo/client";

export const GENERATE_LOST_SALES_REPORT = gql`
  query generateLostSalesReport($fromDate: String!, $toDate: String!) {
    generateLostSalesReport(fromDate: $fromDate, toDate: $toDate) {
      key
      message
    }
  }
`;